<div class="flex flex-col max-width-lg">
  <div class="flex flex-row justify-start items-center mb-56">
    <div *ngIf="showTitle" class="flex flex-auto mat-headline-4 mb-0">{{'MY_SERVICES.TITLE' | transloco}}</div>

    <div class="flex flex-row flex-wrap gap-x-6 mr-40">
      <button class="btn-link mt-6" [ngClass]="{ 'active' : filters.size === 0 }" (click)="clearFilter()">
        {{ 'SANDBOX.ALL' | transloco }} ({{ totalCount }})
      </button>
      <button class="btn-link mt-6" [ngClass]="{ 'active' : filters.has(filter) }"
                *ngFor="let filter of serviceFilters"
                (click)="selectFilter(filter)">
        <ng-container>
          {{ 'SERVICE_STATUS.FILTER.' + filter | transloco }} ({{ filterToCount.get(filter) || 0 }})
        </ng-container>
      </button>
    </div>

    <span *ngIf="!showTitle" class="flex-auto"></span>

    <button class="flex items-center accent" [routerLink]="['/', tenant, 'catalogue']">
      <mat-icon svgIcon="add" class="icon-md mt-2"></mat-icon>
      <span>{{'MY_SERVICES.NEW_SERVICE' | transloco}}</span>
    </button>
  </div>

  <div class="flex flex-row flex-wrap">
    <app-card *ngFor="let cardInfo of filteredCardInfos"
              [serviceCardInfo]="cardInfo"
              (blueprintDeleted)="onBlueprintDeleted($event)"
              [style.max-width.%]="23"
              class="mr-24 mb-48">
    </app-card>
  </div>
</div>
